/* Copyright (c) 2021 Caring Transitions Online Auctions. All Rights Reserved. */

// library imports
import { Component, createRef } from 'react';
import moment from 'moment';
import * as momentTz from 'moment-timezone';

// project imports
import Datatable from 'shared/datatable';
import { locationlist, messageBulkUpdate, messageDelete, messagelist, messageUpdate } from 'shared/settings/apiconfig';

// style imports
import './MessageList.scss';
import axios from 'axios';
import { getSellerHeaders, getSellerUrl } from 'shared/http';
import { ArrayValueReorder } from 'shared/modifiers';
import { Button, Col, Form, Row } from 'react-bootstrap';
import { ToasterMessage } from 'shared/toast/toast';

/**
 * this page is used to list messages
 * 
 * @param props
 * 
 * @returns html code to render the message list
 * 
**/

export class Messages extends Component {

    config;

    constructor(props) {
        super(props);

        this.dataTable = createRef();

        /* initial search state */
        this.initialSearchState = {
            locationid: { field: 'locationid', value: '', op: '=', join: 'AND' },
            saletitle: { field: 'saletitle', value: '', op: 'LIKE', join: 'AND' },
            itemtitle: { field: 'itemtitle', value: '', op: 'LIKE', join: 'AND' },
        }

        this.state = {
            search: {...this.initialSearchState},
            pathname: this.props.location.pathname,
            itemId: this.props.location.itemId,
            searchData: false,
            messageviewItemId :  this.props?.setMessageItemId?.itemId ? this.props?.setMessageItemId?.itemId : this.props?.location?.state?.messageViewitemId ? this.props?.location?.state?.messageViewitemId : '',
            searchData: true,
            locations: [],
            locationlength: 0,
            pageLoading: true,
            tableData: [],
            messageLists: [],
            selectedMessageIds: [],
            enableMessageOpButton: false,
            messageSuccess: { show: false, type: '', message: '' }
        };

        this.checkedBox = {
            messageList: []
        };

        this.config = {
            name: "message",
            url: messagelist,
            params: {},
            columns: [
                { name: '', property: '', width: '50px', columnType: 'custom', customColumn: (event) => this.checkBox(event), customHeader: 'selectAll' },
                {
                    name: '', property: 'id', columnType: 'actions', actions: ['view'], width: '150px',
                    actionEvents: { view: (row, state) => { this.customMessageView(row, state); } }
                },
                { name: 'Bidder Email', property: 'buyeremail', width: '200px', sort: false },
                { name: 'Item Title', property: 'itemtitle', width: '200px', sort: true },
                { name: 'Sale Title', property: 'saletitle', width: '200px', sort: true },
                { name: 'Bidder', property: 'biddername', width: '200px', sort: false },
                { name: 'Date', property: 'createddate', width: '200px', sort: true, columnType: 'custom', customColumn: this.customDateTime }
            ],
            defaultFilter: this.getFilterBasedOnPath(),
            sort: [{ field: 'createddate', direction: 'desc' }],
            pagination: true,
            ignoreRowBackground: true
        };

        this.cloneForm = {
            messageLists: [],
            selectedMessageIds: []
        };

        if (this.props.location.state && this.props.location.state.datatable && this.props.location.state.stateMaintain?.search) {
            let tempSearch = { ...this.initialSearchState };
            let search = this.props.location.state.stateMaintain?.search;

            for (let element in search) {
                let temp = search[element];
                if (typeof temp['value'] === 'string') {
                    temp['value'] = temp['value'].replace(/(^\*)|(\*$)/g, '');
                }
                tempSearch[temp['field']] = temp;
            }
            this.state.search = tempSearch;
        }
    }

    componentDidMount() {
        this.getLocationList();
        if (this.props.location.state && this.props.location.state.datatable && this.props.location.state.stateMaintain?.search) {
            this.enableSearch();
        }
        window.history.pushState(null, null, window.location.pathname);
        window.addEventListener('popstate', this.onBack);
    }

    getFilterBasedOnPath = () => {
        let filter = [];
        let itemid = this.props?.setMessageItemId?.itemId ? this.props.setMessageItemId.itemId : this.state.messageviewItemId ? this.state.messageviewItemId : ''
        if ( itemid ) {
            filter.push({
                field: "itemid",
                value: parseInt(itemid),
                op: "=",
                join: "AND"
            });
        }
        if ( this.props.location.pathname.includes('/messages/deleted') ) {
            filter.push({
                field: "isdeleted",
                value: 1,
                op: "=",
                join: "AND"
            },{
                field: "trash",
                value: 0,
                op: "=",
                join: "AND"
            });
        } else if ( this.props.location.pathname.includes('/messages/read') ) {
            filter.push({
                field: "replied",
                value: 0,
                op: "=",
                join: "AND"
            },{
                field: "read",
                value: 1,
                op: "=",
                join: "AND"
            },{
                field: "isdeleted",
                value: 0,
                op: "=",
                join: "AND"
            },{
                field: "trash",
                value: 0,
                op: "=",
                join: "AND"
            });
        } else {
            filter.push({
                field: this.props.location.pathname.includes('/messages/replied') ? "replied" : "read",
                value: this.props.location.pathname.includes('/messages/read') || this.props.location.pathname.includes('/messages/replied') ? 1 : 0,
                op: "=",
                join: "AND"
            }, {
                field: "isdeleted",
                value: 0,
                op: "=",
                join: "AND"
            },{
                field: "trash",
                value: 0,
                op: "=",
                join: "AND"
            });
        }
        return filter;
    };

    customMessageView = (row, state) => {
        if (this.props.location.pathname.includes('/messages/unread')) {
            const data = { "ids": [row.id], "read": 1 };
            axios.post(getSellerUrl(messageBulkUpdate), JSON.stringify({ data: data }), getSellerHeaders())
            .then(async (response) => {})
            .catch(error => {});
        }
        this.props.history.push({ pathname: `/messages/reply/${row.id}`, state: { ...state, row, stateMaintain: this.state, messageViewitemId : this.state.messageviewItemId }});
    };

    customDateTime = (values) => {
        if (values['createddate'] != null) {
            return `${moment.utc(values['createddate']).local().format('MM/DD/YYYY hh:mm A')} ${momentTz.tz(momentTz.tz.guess()).zoneAbbr()}`;
        }
        else
            return '- - -';
    }

    /* custom checkbox*/
    checkBox = (value) => {
        return (
            <div className="custom-header-checkbox">
                <Form>
                    <div className={`custom-checkbox-div ${this.checkBoxChecked(value.id) ? 'checked' : ''}`} onClick={(event) => { event.stopPropagation(); this.selectItems(event, value) }}></div>
                </Form>
            </div>
        );
    }

    /* Called when table checkbox change */
    selectItems = (event, row) => {
        const index = this.state.messageLists.findIndex(x => x.id === row.id);
        if (index === -1) {
            this.state.messageLists.push(row);
            const addCheck = this.state.messageLists.length === this.state.tableData.data.length;
            this.setState({
                ...this.state,
                selectedMessageIds: this.state.messageLists
            }, () => {
                this.cloneForm.messageLists = this.state.messageLists;
                this.enableButton();
                this.checkBoxUpdate(addCheck);
            });
        } else {
            this.state.messageLists.splice(index, 1);
            const removeCheck = this.state.messageLists.length === this.state.tableData.data.length;
            this.setState({
                ...this.state,
                selectedMessageIds: this.state.messageLists
            }, () => {
                this.cloneForm.messageLists = this.state.messageLists;
                this.enableButton();
                this.checkBoxUpdate(removeCheck);
            });
        }
    }

    /* Return checked or not based on id for message checkbox */
    checkBoxChecked = (id) => {
        return this.cloneForm.messageLists.findIndex(x => x.id === id) > -1;
    }

    onBack = (e) => {
        e.preventDefault();
        window.history.pushState(null, null, window.location.pathname);
    }

    /* Get Location list */
    getLocationList = async () => {
        await axios.all([await axios.post(getSellerUrl(locationlist), JSON.stringify({ field: ['id', 'title'] }), getSellerHeaders())]).then(response => {
            this.setState({
                ...this.state,
                locations: ArrayValueReorder(response[0].data.data, 'title'),
                search: {
                    ...this.state.search,
                    locationid: {
                        ...this.state.search.locationid,
                        value: response[0].data.data.length === 1 ? response[0].data.data['id'] : this.state.search.locationid.value,
                    }
                },
                pageLoading: false
            });
        })
        .catch(error => {
            this.setState({
                pageLoading: false
            });
        });
    }

    // handle enter key search
    _handleKeyDown = (e) => {
        if (e.key === 'Enter' && this.state.search.locationid.value) {
            this.enableSearch()
        }
    }

    /* called when search input changes */
    searchInputChange = (event) => {
        let eventValue = event.target.value;
        this.setState({
            ...this.state,
            search: {
                ...this.state.search,
                [event.target.name]: {
                    ...this.state.search[event.target.name],
                    value: eventValue
                }
            },
            searchData: false
        });
    }

    /* called when clear in search clicked */
    resetState = () => {
        this.setState({
            ...this.state,
            search: this.initialSearchState,
            searchData: false,
            selectedMessageIds: [],
            messageLists: [],
            enableMessageOpButton: false
        }, () => {
            this.dataTable.current.searchData();
        });
    }

    /* called when search button clicked */
    enableSearch = () => {
        let search = {};
        search = {
            locationid: { ...this.state.search.locationid, value: this.state.search.locationid.value ? this.state.search.locationid.value : '' },
            saletitle: { ...this.state.search.saletitle, value: this.state.search.saletitle.value ?  this.state.search.saletitle.value : '' },
            itemtitle: { ...this.state.search.itemtitle, value: this.state.search.itemtitle.value ? this.state.search.itemtitle.value : '' },
        }
        this.setState({
            search: search,
            searchData: true
        }, () => {
            this.dataTable.current.searchData();
        });
    }

    updateTableData = (event) => {
        this.setState({
            ...this.state,
            tableData: event
        });
    }

    /* Called when table header checkbox change */
    allItemsSelect = (event) => {
        if (event) {
            this.setState({
                ...this.state,
                messageLists: JSON.parse(JSON.stringify(this.state.tableData.data)),
                selectedMessageIds: JSON.parse(JSON.stringify(this.state.tableData.data)),
            }, () => {
                this.enableButton();
            });
            this.cloneForm.messageLists = JSON.parse(JSON.stringify(this.state.tableData.data));
            this.checkBoxUpdate(true);
        } else {
            this.setState({
                ...this.state,
                messageLists: [],
                selectedMessageIds: []
            }, () => {
                this.enableButton();
            });
            this.cloneForm.messageLists = [];
            this.checkBoxUpdate(false);
        }
    }

    /* Enable and disable button */
    enableButton = () => {
        this.setState({ enableMessageOpButton: this.cloneForm.messageLists.length > 1 });
    }

    /* Checkbox update */
    checkBoxUpdate = (value) => {
        this.dataTable.current.checkBoxHandle(value);
    }

    /* Message OP button*/
    messagebtnSelect = (type) => {
        var ids = [];
        ids = this.state.messageLists.map(item => item.id);
        
        if (type == "allRead") {
            const data = { "ids": ids, "read": 1 };
            axios.post(getSellerUrl(messageBulkUpdate), JSON.stringify({ data: data }), getSellerHeaders()).then(
                response => {
                    if (response.data.status.toLowerCase() === 'success') {
                        this.setState({
                            messageSuccess: { show: true, type: 'success', message: 'Message(s) is marked as read successfully' },
                            selectedMessageIds: [],
                            messageLists: []
                        }, () => {
                            setTimeout(() => {
                                this.setState({
                                    messageSuccess: { show: false, type: '', message: '' }
                                })
                            }, 3000)
                        })
                        this.dataTable.current.searchData();
                    }
                }).catch(error => {
                    this.setState({
                        messageSuccess: { show: true, type: 'danger', message: 'Error while reading' }
                    }, () => {
                        setTimeout(() => {
                            this.setState({
                                messageSuccess: { show: false, type: '', message: '' }
                            })
                        }, 3000)
                    })
                });
        } else if (type == "allUnRead") {
            const data = { "ids": ids, "read": 0 };
            axios.post(getSellerUrl(messageBulkUpdate), JSON.stringify({ data: data }), getSellerHeaders()).then(
                response => {
                    if (response.data.status.toLowerCase() === 'success') {
                        this.setState({
                            messageSuccess: { show: true, type: 'success', message: 'Message(s) is marked as unread successfully' },
                            selectedMessageIds: [],
                            messageLists: []
                        }, () => {
                            setTimeout(() => {
                                this.setState({
                                    messageSuccess: { show: false, type: '', message: '' }
                                })
                            }, 3000)
                        })
                        this.dataTable.current.searchData();
                    }
                }).catch(error => {
                    this.setState({
                        messageSuccess: { show: true, type: 'danger', message: 'Error while reading' }
                    }, () => {
                        setTimeout(() => {
                            this.setState({
                                messageSuccess: { show: false, type: '', message: '' }
                            })
                        }, 3000)
                    })
                });
        } else if (type == "deleteAll") {
            const data = { "ids": ids, "isdeleted": 1 };
            axios.post(getSellerUrl(messageBulkUpdate), JSON.stringify({ data: data }), getSellerHeaders()).then(
                response => {
                    if (response.data.status.toLowerCase() === 'success') {
                        this.setState({
                            messageSuccess: { show: true, type: 'success', message: 'Message(s) is deleted successfully' },
                            selectedMessageIds: [],
                            messageLists: []
                        }, () => {
                            setTimeout(() => {
                                this.setState({
                                    messageSuccess: { show: false, type: '', message: '' }
                                })
                            }, 3000)
                        })
                        this.dataTable.current.searchData();
                    }
                }).catch(error => {
                    this.setState({
                        messageSuccess: { show: true, type: 'danger', message: 'Error while deleting' }
                    }, () => {
                        setTimeout(() => {
                            this.setState({
                                messageSuccess: { show: false, type: '', message: '' }
                            })
                        }, 3000)
                    })
                });
        } else if (type == "undoDeleteAll") {
            const data = { "ids": ids, "isdeleted": 0 };
            axios.post(getSellerUrl(messageBulkUpdate), JSON.stringify({ data: data }), getSellerHeaders()).then(
                response => {
                    if (response.data.status.toLowerCase() === 'success') {
                        this.setState({
                            messageSuccess: { show: true, type: 'success', message: 'Action undone' },
                            selectedMessageIds: [],
                            messageLists: []
                        }, () => {
                            setTimeout(() => {
                                this.setState({
                                    messageSuccess: { show: false, type: '', message: '' }
                                })
                            }, 3000)
                        })
                        this.dataTable.current.searchData();
                    }
                }).catch(error => {
                    this.setState({
                        messageSuccess: { show: true, type: 'danger', message: 'Error while unreading' }
                    }, () => {
                        setTimeout(() => {
                            this.setState({
                                messageSuccess: { show: false, type: '', message: '' }
                            })
                        }, 3000)
                    })
                });
        } else if (type == "trash") {
            const config = getSellerHeaders();
            config['data'] = { data: { "ids" : ids } };
            axios.delete(getSellerUrl(messageDelete), config).then(
                response => {
                    if (response.data.status.toLowerCase() === 'success') {
                        this.setState({
                            messageSuccess: { show: true, type: 'success', message: 'Message(s) is deleted successfully' },
                            selectedMessageIds: [],
                            messageLists: []
                        }, () => {
                            setTimeout(() => {
                                this.setState({
                                    messageSuccess: { show: false, type: '', message: '' }
                                })
                            }, 3000)
                        })
                        this.dataTable.current.searchData();
                    }
                }).catch(error => {
                    this.setState({
                        messageSuccess: { show: true, type: 'danger', message: 'Error while deleting' }
                    }, () => {
                        setTimeout(() => {
                            this.setState({
                                messageSuccess: { show: false, type: '', message: '' }
                            })
                        }, 3000)
                    })
                });
        }
    }

    render() {
        return (
            <div className={`${this.state.pageLoading ? 'h-100' : ''} overflow-auto`}>
                {
                    <div>
                        <div className="sale-search" style={{ backgroundColor: '#BBC7D6' }}>
                            <div className="sales-list-search">
                                <Form className="sales-list-font">
                                    <div className="sales-search-container">
                                        <Row md={5}>
                                            <Col>
                                                <label>Location *</label>
                                                <Form.Control as="select" name="locationid" defaultValue={""} value={this.state.search.locationid.value} onChange={(event) => this.searchInputChange(event)}>
                                                    <option value="" disabled>Please select location</option>
                                                    {/* <option value={""}>All</option> */}
                                                    {this.state.locations.map((loc, index) =>
                                                        <option key={index} value={loc.id}>{loc.title}</option>
                                                    )}
                                                </Form.Control>
                                            </Col>
                                            <Col>
                                                <label>Sale Title</label>
                                                <Form.Control onKeyDown={this._handleKeyDown} name="saletitle" value={this.state.search.saletitle.value ? this.state.search.saletitle.value : ''} onChange={(event) => { this.searchInputChange(event) }}>
                                                </Form.Control>
                                            </Col>
                                            <Col>
                                                <label>Item Name</label>
                                                <Form.Control onKeyDown={this._handleKeyDown} name="itemtitle" value={this.state.search.itemtitle.value ? this.state.search.itemtitle.value : ''} onChange={(event) => { this.searchInputChange(event) }}>
                                                </Form.Control>
                                            </Col>
                                            <Col>
                                                <div className="mt-3">
                                                    <Button className="clear-button" onClick={() => this.resetState()}>Clear All</Button>
                                                    <Button variant="seller-search" disabled={!this.state.search.locationid.value} onClick={() => this.enableSearch()}>Search</Button>
                                                </div>
                                            </Col>
                                        </Row>
                                    </div>
                                </Form>
                            </div>
                        </div>
                        <div className="message-list">
                            <div className='d-flex justify-content-end'>
                                <div>
                                    {
                                        this.state.messageSuccess.show ?
                                            <ToasterMessage type={this.state.messageSuccess.type} message={this.state.messageSuccess.message} className="alert-handle mt-2 mr-2"></ToasterMessage>
                                            : null
                                    }
                                </div>
                                <div className='d-flex justify-content-end'>
                                    {
                                        this.props.location.pathname.includes('/messages/unread') ? 
                                        <>
                                            <Button className='btn-secondary mr-2' disabled={this.state.selectedMessageIds.length === 0 && !this.state.enableMessageOpButton} onClick={() => {this.messagebtnSelect("allRead")}}>Mark As Read ({this.state.selectedMessageIds.length})</Button>
                                            <Button className='btn-secondary' disabled={this.state.selectedMessageIds.length === 0 && !this.state.enableMessageOpButton} onClick={() => {this.messagebtnSelect("deleteAll")}}>Delete ({this.state.selectedMessageIds.length})</Button>
                                        </> : this.props.location.pathname.includes('/messages/read') ? 
                                        <>
                                            <Button className='btn-secondary mr-2' disabled={this.state.selectedMessageIds.length === 0 && !this.state.enableMessageOpButton} onClick={() => {this.messagebtnSelect("allUnRead")}}>Mark As Unread ({this.state.selectedMessageIds.length})</Button>
                                            <Button className='btn-secondary' disabled={this.state.selectedMessageIds.length === 0 && !this.state.enableMessageOpButton} onClick={() => {this.messagebtnSelect("deleteAll")}}>Delete ({this.state.selectedMessageIds.length})</Button>
                                        </> : this.props.location.pathname.includes('/messages/deleted') ? 
                                        <>
                                            <Button className='btn-secondary mr-2' disabled={this.state.selectedMessageIds.length === 0 && !this.state.enableMessageOpButton} onClick={() => {this.messagebtnSelect("trash")}}>Trash ({this.state.selectedMessageIds.length})</Button>
                                            <Button className='btn-secondary' disabled={this.state.selectedMessageIds.length === 0 && !this.state.enableMessageOpButton} onClick={() => {this.messagebtnSelect("undoDeleteAll")}}>Undo Delete ({this.state.selectedMessageIds.length})</Button>
                                        </> : this.props.location.pathname.includes('messages/replied') ? 
                                        <>
                                            <Button className='btn-secondary' disabled={this.state.selectedMessageIds.length === 0 && !this.state.enableMessageOpButton} onClick={() => {this.messagebtnSelect("deleteAll")}}>Delete ({this.state.selectedMessageIds.length})</Button>
                                        </> : ''
                                    }
                                </div>
                            </div>
                            <Datatable {...this.props} config={this.config} search={this.state.searchData ? { search: { ...this.state.search }, searchData: this.state.searchData } : null} ref={this.dataTable}
                                onDataUpdate={this.updateTableData} allItemsSelect={this.allItemsSelect} />
                        </div>
                    </div>
                }
            </div>
        );
    }
}
